export default "__VITE_ASSET__DvfnWld4__"